export default __webpack_public_path__ + "static/media/Obstacle1Group.00129925.png";